import { render, staticRenderFns } from "./Wp_home_all_model.vue?vue&type=template&id=4cd0787a&scoped=true&"
import script from "./Wp_home_all_model.vue?vue&type=script&lang=js&"
export * from "./Wp_home_all_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd0787a",
  null
  
)

export default component.exports